import AddIcon from "@mui/icons-material/Add";
import * as React from "react";
import {MouseEventHandler} from "react";
import {Grid, useTheme} from "@mui/material";
import CustomSwitch from "./CustomSwitch";
import {Link} from "react-router-dom";

export type ActiveSwitchModel = {
    label: string;
    handleChange: Function;
    value: boolean;
}

export type AddIconModel = {
    onClick: MouseEventHandler<HTMLDivElement>;
}

const BasicToolbar = ({addIcon, activeSwitch, url}: {
    addIcon?: AddIconModel,
    activeSwitch?: ActiveSwitchModel
    url?: string
}) => {
    // Use Theme
    const theme = useTheme();

    return (
        <Grid container alignItems={"center"}>
            {activeSwitch && <CustomSwitch label={activeSwitch.label}
                                           handleChange={activeSwitch.handleChange}
                                           readOnly={false}
                                           value={activeSwitch.value}
            />}
            {addIcon && <div style={{cursor: "pointer"}}
                             onClick={addIcon.onClick}
            >
                {url ? <Link to={url as string} target="_blank">
                        <AddIcon sx={{color: theme.palette.accent.main}}/>
                    </Link> :
                    <AddIcon sx={{color: theme.palette.accent.main}}/>
                }
            </div>}
        </Grid>
    );
};

export default BasicToolbar;